import type { IValidatedResponse } from '../../../httpClient';
import { getRequest } from '../../../httpClient';
import type { IBillingListParams } from '../billing-list-params';
import { buildBillingQueryString } from '../build-billing-query-string';
import type { IListSubscriptionsResponse } from './list-subscriptions-response';
import { listSubscriptionsResponseSchema } from './list-subscriptions-response';

export async function listAdminSubscriptionsApi(
  params?: IBillingListParams,
): Promise<IValidatedResponse<IListSubscriptionsResponse>> {
  const qs = buildBillingQueryString(params);
  return getRequest<IListSubscriptionsResponse>({
    path: `/sys/billing/subscriptions${qs ? `?${qs}` : ''}`,
    schema: listSubscriptionsResponseSchema,
  });
}
